import { Notification, NotificationPage } from '../../application/entities/notification.entity';
import {
  NotificationItemDto,
  NotificationListResponseDto,
} from '../dto/notification-response.dto';

export function toNotification(dto: NotificationItemDto): Notification {
  return {
    uuid: dto.uuid,
    type: dto.type,
    params: dto.params ?? {},
    fallbackMessage: dto.fallbackMessage,
    requirementUuid: dto.requirementUuid,
    analysisUuid: dto.analysisUuid,
    read: dto.read,
    createdAt: dto.createdAt,
  };
}

export function toNotificationPage(response: NotificationListResponseDto): NotificationPage {
  return {
    items: response.data.notifications.map(toNotification),
    paging: {
      page: response.metadata.paging.page,
      limit: response.metadata.paging.limit,
      total: response.metadata.paging.total,
      totalPages: response.metadata.paging.totalPages,
    },
  };
}
